import { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useFetch from '../../../hooks/use-fetch';
import {DateTime} from 'luxon';



import { Dialog, Transition } from '@headlessui/react';
import Form, { CheckboxField, Field } from '@atlaskit/form';
import TextField from '@atlaskit/textfield';
import { TimePicker } from '@atlaskit/datetime-picker';

import ErrorsBlock from '../../../components/errors';
import { Checkbox } from '@atlaskit/checkbox';


export default function AddScreen({closeModal, isOpen, reloadTable, tableData}) {
  const {t} = useTranslation();
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [publicScreen, setPublicScreen] = useState(true);
  const [errors, setErrors] = useState([]);

  const [{response: saveResponse, isLoading: saveIsLoading, error: saveError}, doFetchItemSave] = useFetch(`/directories/screens`);

  const onSaveClick = (data) => {
    if(saveIsLoading) {return}
    doFetchItemSave({
      method: 'POST',
      data: {
        data: data
      }
    });
  };

  useEffect(() => {
    if (!saveResponse) {
      return;
    }
    reloadTable()
    closeModal()
    setErrors([])
  },[saveResponse])

  useEffect(() => {
    if(!saveError) {return}
    setErrors(saveError?.errors)
  }, [saveError])


  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        onClose={closeModal}
      >
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
        <div className="min-h-screen px-4 text-center">
          {/* <span className="inline-block h-screen align-middle" aria-hidden="true">&#8203;</span> */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full max-w-md p-6 mt-32 my-8 text-left align-middle transition-all transform bg-white shadow-xl rounded">
              <Dialog.Title
                as="h3"
                className="text-lg font-medium leading-6 text-gray-900"
              >
                {t("adding_screen")}
              </Dialog.Title>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  {t('screen_add_form_text')}
                </p>
              </div>
              {errors.length > 0  ? <ErrorsBlock errors={errors}/> : ''}
              <Form onSubmit={data => onSaveClick(data)}>
                {({ formProps }) => (
                  <form {...formProps}>
                    <Field name="name" defaultValue={name} label={t('screen_name')} isRequired>
                      {({ fieldProps }) => <TextField {...fieldProps} />}
                    </Field>
                    <Field name="slug" defaultValue={slug} label={t('screen_slug')} isRequired>
                      {({ fieldProps }) => <TextField {...fieldProps} />}
                    </Field>
                    <CheckboxField name="public" defaultIsChecked={publicScreen}>
                      {({ fieldProps }) => <Checkbox className="in" size="medium" {...fieldProps} label={t('screen_public')}/>}
                    </CheckboxField>

                    <div className="flex justify-between mt-8">
                      <button 
                        type="submit" 
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                      >
                        {t('save')}
                      </button>
                      <button 
                        onClick={() => closeModal()}
                        type="button" 
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-900 bg-gray-100 border border-transparent rounded hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                      >
                        {t('cancel')}
                      </button>
                    </div>
                  </form>
                )}
              </Form>
            </div>
          </Transition.Child>
        </div>
        
      </Dialog>
    </Transition>
  )
}
